// Vue 系优先引用，保证 vendor-vue 先于 element-plus 加载，避免部署报错
import { createApp } from 'vue'
import router from './router.tsx'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import './assets/style/global.css'
import { App } from './app'
import { initStores } from '@/init/init.ts'
import { Icon } from '@iconify/vue'
import { ensureIconsLoaded } from '@/init/init-iconify'
import * as Sentry from '@sentry/vue'

import 'element-plus/theme-chalk/dark/css-vars.css'
import './assets/style/element-theme.css'
import { atomsComponents } from '@/atoms'
import { getInitialLocale, i18n, loadLocaleMessages } from '@/i18n'
import { initDirectives } from '@/init/init-directives'

console.log('welcome to skyproduction, mode: ', import.meta.env.MODE)

const app = createApp(App)
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
app.use(router)
app.use(pinia)
app.use(i18n)

// Initialize stores after pinia is registered
initStores()

// 注册 atoms 全局组件
Object.keys(atomsComponents).forEach(key => {
  app.component(key, atomsComponents[key as keyof typeof atomsComponents])
})

// 注册全局指令
initDirectives(app)

if (import.meta.env.MODE !== 'development') {
  Sentry.init({
    app,
    dsn: 'https://7576e246493101a6235cc3c58f81cd81@sentry.mydramawave.com/5',
    environment: import.meta.env.MODE,
    release: 'ai-tools-web@' + import.meta.env.VITE_VERSION + '-' + Date.now(),
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration({ router: router }),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: ['localhost', /^https:\/\/admin-test.mydramawave\.com\/api/],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  })
}
// eslint-disable-next-line vue/multi-word-component-names
app.component('Icon', Icon)
void Promise.all([loadLocaleMessages(getInitialLocale()), ensureIconsLoaded()]).then(() => {
  app.mount('#app')
})
